var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPoliciesManagem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_1839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2148 12.4163L15.7087 21.4788L15.9849 24.9386L18.9062 23.0664L23.4096 14.0067L20.2148 12.4163ZM21.8025 9.21875L20.7422 11.3504L23.9397 12.9408L25 10.8092L21.8025 9.21875ZM2.67857 23.2143C2.18471 23.2143 1.78571 22.8153 1.78571 22.3214V2.67857C1.78571 2.18471 2.18471 1.78571 2.67857 1.78571H17.832C18.3259 1.78571 18.7249 2.18471 18.7249 2.67857V9.82143C18.7249 10.3153 19.1239 10.7143 19.6177 10.7143C20.1116 10.7143 20.5106 10.3153 20.5106 9.82143V1.78571C20.5106 0.800781 19.7098 0 18.7249 0H1.78571C0.797991 0 0 0.800781 0 1.78571V23.2143C0 24.1992 0.800781 25 1.78571 25H13.4096C13.9035 25 14.3025 24.601 14.3025 24.1071C14.3025 23.6133 13.9035 23.2143 13.4096 23.2143H2.67857Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5997 5.3291H4.8826C4.38874 5.3291 3.98975 5.7281 3.98975 6.22196C3.98975 6.71582 4.38874 7.11482 4.8826 7.11482H15.5997C16.0935 7.11482 16.4925 6.71582 16.4925 6.22196C16.4953 5.7281 16.0935 5.3291 15.5997 5.3291ZM15.5997 10.6862H4.8826C4.38874 10.6862 3.98975 11.0852 3.98975 11.5791C3.98975 12.073 4.38874 12.472 4.8826 12.472H15.5997C16.0935 12.472 16.4925 12.073 16.4925 11.5791C16.4953 11.0852 16.0935 10.6862 15.5997 10.6862ZM10.2425 16.0434H4.8826C4.38874 16.0434 3.98975 16.4424 3.98975 16.9362C3.98975 17.4301 4.38874 17.8291 4.8826 17.8291H10.2425C10.7364 17.8291 11.1354 17.4301 11.1354 16.9362C11.1354 16.4424 10.7364 16.0434 10.2425 16.0434Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_1839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPoliciesManagem);
export default __webpack_public_path__ + "static/media/ic_policies_managem.0ec529d2b8d7dbd8c4e0a0f9f07757ef.svg";
export { ForwardRef as ReactComponent };